<template>
    <div class="form-group" :class="{ 'col': col}">
        <label :for="id">{{ title }} <span v-if="required" class="required clo-red text-20">*</span></label>
        <div class="position-relative">
            <input
                :value="value"
                type="text"
                class="form-control"
                :id="id"
                :placeholder="placeholder"
                :maxlength="maxlength"
                @focus="focusHandler(id)"
                @blur="handleBlur"
                @keyup="onchangeValue"
                @keypress="isNumber($event)"
            />
            <!-- hide if not text -->
            <i class="btn-clear" v-if="id == 'name'" @click="clearInput">
                <svg aria-hidden="true" width="20" height="20" title="FPT TELECOM">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-delete"></use>
                </svg>
            </i>
        </div>
        <!-- hide if validated -->
        <small v-if="input_error" id="" class="form-text text-12 clo-red">{{ input_error }}</small>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
        },
        maxlength: {
            type: String,
            defaults: 100,
        },
        required: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'text',
        },
        id: {
            type: String,
        },
        value: {
            type: String,
        },
        input_error: {
            type: String,
            default: '',
        },
        col: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            errors: [],
            otherKeyboard: false,
            handleFocus: false,
        };
    },
    methods: {
        focusHandler(id) {
            if (this.id == id) {
                this.handleFocus = true;
            } else {
                this.handleFocus = false;
            }
        },
        handlePaste(evt) {
            let data = evt.clipboardData.getData('text/plain');
            this.updateData(data);
            evt.target.blur();
            return true;
        },
        handleBlur() {
            this.handleFocus = false;
        },
        updateData(text) {
            this.$emit('input', text);
        },
        isNumber(evt) {
            if (this.type == 'number') {
                evt = evt ? evt : window.event;
                var charCode = evt.which ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) || evt.target.value.length >= this.maxlength) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },
        onchangeValue(event) {
            /*
                AFAIK keyCode 229 means that user pressed some button, but input method is still processing that.
                This is a standard behavior for some input methods like entering japaneese or сhinese hieroglyphs.
                If an Input Method Editor is processing key input and the event is keydown, return 229.
                http://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
            */
            if (event.keyCode === 229) {
                this.otherKeyboard = true;
            }
            if (!this.isDate || isNaN(event.key) || this.otherKeyboard) {
                this.updateData(event.target.value);
                if (event.keyCode == 13) {
                    // press Enter
                    event.target.blur();
                    this.$emit('pressEnter');
                }
            } else {
                const format = [2, 2];
                const split = event.target.value.split('/');
                if (
                    split.length &&
                    format[split.length - 1] &&
                    split[split.length - 1].length === format[split.length - 1]
                ) {
                    this.updateData(event.target.value + '/');
                } else {
                    this.updateData(event.target.value);
                }
            }
        },
        clearInput(){
            this.value = ''
            this.updateData('')
        }
    },
};
</script>
